<div class="order-fulfilled-template-content">
  <div class="conditions">
    <ng-container #selectOrList *ngFor="let allConditionsSelectValue of currentAllConditionsSelectValue; let j = index">
      <div class="outline-and-conditions">
        <ng-container
          #selectList
          *ngFor="let conditionSelectValue of currentAllConditionsSelectValue[j]; let i = index">
          <div class="condition">
            <div class="header-text" *ngIf="i == 0; else othwerWise"><b>IF</b></div>
            <ng-template #othwerWise>
              <div class="header-text">AND <b>IF</b></div>
            </ng-template>
            <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
            <div class="select-wrapper">
              <mat-select
                #conditionSelect
                class="pdq-mat-select pdq-mat-select--ghost-underline"
                panelClass="pdq-mat-select--panel"
                placeholder="trigger"
                [(value)]="currentAllConditionsSelectValue[j][i]"
                (selectionChange)="changeConditionSelect($event, [j, i])"
                [attr.data-2dIndex]="j + ',' + i">
                <mat-option
                  *ngFor="let condition of conditions[0].values"
                  [value]="condition"
                  [disabled]="
                    condition.disabled ||
                    ruleTemplateService.isOptionAlreadyChosen(
                      condition,
                      i,
                      currentAllConditionsSelectValue[j],
                      currentOperatorValue[j]
                    )
                  ">
                  {{ condition.text }}
                </mat-option>
              </mat-select>
            </div>
            <span
              [ngSwitch]="
                currentAllConditionsSelectValue[j] &&
                currentAllConditionsSelectValue[j][i] &&
                currentAllConditionsSelectValue[j][i].name
              ">
              <div *ngSwitchCase="'orderFulfillmentStatus'" class="condition-container" floatLabel="never">
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [options]="fulfillmentStatusOptions"
                  [defaultOption]="currentFulfillmentStatusValue[j][i] || fulfillmentStatusOptions[0]"
                  buttonFontSize="16"
                  (onChange)="onOrderFulfillmentStatusConditionChanged($event, [j, i])">
                </pdq-dropdown>
              </div>
            </span>

            <span class="action-buttons">
              <pdq-button
                class="delete-button"
                *ngIf="i > 0 || j > 0"
                variant="ghost"
                icon="delete"
                (onClick)="removeCondition([j, i])"></pdq-button>
              <pdq-button
                class="add-button"
                *ngIf="
                  i == currentAllConditionsSelectValue[j].length - 1 && checkIfAllValuesInsertedForConditionGroup(j)
                "
                variant="ghost"
                icon="more"
                (onClick)="addCondition([j, i + 1])">
              </pdq-button>
            </span>
          </div>
        </ng-container>
      </div>

      <div class="add-or-button-div">
        <pdq-button
          class="add-or-button"
          [disabled]="j != currentAllConditionsSelectValue.length - 1"
          *ngIf="j != currentAllConditionsSelectValue.length - 1 || checkIfAllValuesInserted()"
          (onClick)="addOrCondition(j + 1)">
          + OR
        </pdq-button>
      </div>
    </ng-container>
  </div>

  <div class="action">
    <b class="header-text">THEN </b>
    <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
    <div class="select-wrapper" style="margin-top: 8px" *ngIf="!currentActionSelectValue">
      <mat-select
        panelClass="pdq-mat-select--panel"
        class="pdq-mat-select pdq-mat-select--ghost-underline"
        placeholder="action"
        [(value)]="currentActionSelectValue"
        (selectionChange)="changeActionSelect($event)">
        <mat-option
          *ngFor="let action of actions[0].values; index as actionKey"
          [value]="action"
          [disabled]="isActionDisabled(action, actionKey)">
          <span [innerHTML]="getFormattedText(action.text)"></span>
        </mat-option>
      </mat-select>
    </div>
    <span [ngSwitch]="currentActionSelectValue && currentActionSelectValue.name" class="full-width">
      <span class="action-select" *ngSwitchCase="'fulfillOrder'">
        <span [innerHTML]="getActionText(currentActionSelectValue)"></span>
        <span
          class="reset-btn"
          [matTooltip]="'Reset action'"
          matTooltipClass="pdq-mat-tooltip"
          (click)="onResetActionSelectValue()"></span>
      </span>
      <span class="action-select full-width" *ngSwitchCase="'addTags'">
        <span [innerHTML]="getActionText(currentActionSelectValue)" class="aligned"></span>
        <app-add-tags
          [isDialog]="false"
          (tagsChanged)="tagsChanged($event, 'add')"
          [initialTags]="currentActionAddTagsValue"></app-add-tags>
        <pdq-icon
          (click)="onResetActionSelectValue()"
          icon="close"
          class="close aligned"
          size="medium"
          color="flint"
          [matTooltip]="'Reset action'"
          matTooltipClass="pdq-mat-tooltip">
        </pdq-icon>
      </span>
      <span class="action-select full-width" *ngSwitchCase="'deleteTags'">
        <span [innerHTML]="getActionText(currentActionSelectValue)" class="aligned"></span>
        <app-add-tags
          [isDialog]="false"
          (tagsChanged)="tagsChanged($event, 'delete')"
          [initialTags]="currentActionDeleteTagsValue"></app-add-tags>
        <pdq-icon
          (click)="onResetActionSelectValue()"
          icon="close"
          class="close aligned"
          size="medium"
          color="flint"
          [matTooltip]="'Reset action'"
          matTooltipClass="pdq-mat-tooltip">
        </pdq-icon>
      </span>
    </span>
  </div>

  <div class="approve-notification" *ngIf="headsUp?.length">
    <span>
      <b>Heads up:</b>
      <span *ngFor="let message of headsUp" class="list-item notification-item">
        <span [innerHtml]="message"></span>
      </span>
    </span>
  </div>
</div>
